import { render, staticRenderFns } from "./EditPropertyCompany.vue?vue&type=template&id=217bfe57"
import script from "./EditPropertyCompany.vue?vue&type=script&lang=js"
export * from "./EditPropertyCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports